import axios from 'services/axios';
import { GetOperationCountParams, OperationCount } from '../types';

const VITE_APP_API_URL = import.meta.env.VITE_APP_API_URL;

type GetOperationCountResponse = {
  data: { data: OperationCount[]; number_of_accounts: number; total_operation_count: number };
};

export const getOperationCount = async ({
  org_id,
  partner,
}: GetOperationCountParams): Promise<GetOperationCountResponse['data']['data']> => {
  try {
    const response: { data: GetOperationCountResponse['data'] } = await axios.get(
      `${VITE_APP_API_URL}/opensearch/v3/operation-count`,
      {
        params: {
          org_id,
          partner,
        },
      },
    );
    return response.data.data;
  } catch (err: any) {
    console.error(err);
    return [];
  }
};
